module.exports = __webpack_public_path__ + "img/12-995fdb97.png";